import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

export default function ContactForm({ projectName }) {
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);

        try {
            await emailjs.sendForm(
                "service_gdqp34f",
                "template_7x6r5ia",
                formRef.current,
                "nMJJasCBa1ghmUdYi"
            );

            navigate("/thanks");
        } catch (err) {
            console.error("Errore invio email:", err);
            alert("Si è verificato un errore. Riprova più tardi.");
        } finally {
            setSending(false);
        }
    };

    return (
        <section id="contact-form" className="py-16 sm:py-20">
            <div className="max-w-4xl mx-auto px-4">
                <div className="rounded-3xl border border-dark-100 bg-gradient-to-br from-[#0A0E14] via-[#121826] to-[#0A0E14] p-8 sm:p-10 shadow-2xl">
                    <h3 className="text-2xl sm:text-3xl font-semibold text-center text-light">
                        Richiedi un'assistenza personalizzata
                    </h3>
                    <p className="text-gray-400 mt-3 text-center max-w-2xl mx-auto">
                        Raccontaci la tua esigenza, ti contatteremo per mostrarti come {projectName+" "}
                        può aiutare concretamente la tua azienda.
                    </p>

                    <form ref={formRef} onSubmit={handleSubmit} className="mt-8 space-y-4">

                        <input type="hidden" name="title" value="Richiesta assistenza personalizzata"/>

                        <div className="grid sm:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm text-gray-400 mb-1">Nome e cognome</label>
                                <input
                                    type="text"
                                    name="name"
                                    required
                                    className="w-full rounded-xl border border-dark-100 bg-dark/40 text-gray-100 placeholder:text-gray-500 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#7457FF]"
                                    placeholder="Es. Mario Rossi"
                                />
                            </div>

                            <div>
                                <label className="block text-sm text-gray-400 mb-1">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    required
                                    className="w-full rounded-xl border border-dark-100 bg-dark/40 text-gray-100 placeholder:text-gray-500 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#7457FF]"
                                    placeholder="nome@azienda.com"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm text-gray-400 mb-1">Azienda / Organizzazione</label>
                            <input
                                type="text"
                                name="company"
                                className="w-full rounded-xl border border-dark-100 bg-dark/40 text-gray-100 placeholder:text-gray-500 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#7457FF]"
                                placeholder="Nome azienda (opzionale)"
                            />
                        </div>

                        <div>
                            <label className="block text-sm text-gray-400 mb-1">Contattaci</label>
                            <textarea
                                rows={4}
                                name="message"
                                required
                                className="w-full rounded-xl border border-dark-100 bg-dark/40 text-gray-100 placeholder:text-gray-500 p-3 focus:outline-none focus:ring-2 focus:ring-[#7457FF]"
                                placeholder="Anticipaci qualcosa di voi e del vostro business..."
                            />
                        </div>

                        <div className="pt-2">
                            <label className="flex items-start gap-2 text-[11px] text-gray-400">
                                <input
                                    type="checkbox"
                                    name="privacy_consent"
                                    required
                                    className="mt-1 h-4 w-4 rounded border-dark-100 bg-dark/40 text-[#7457FF] focus:ring-[#7457FF]"
                                />
                                <span>
                                    Inserendo i tuoi dati (nome, cognome, email e messaggio) acconsenti al trattamento
                                    delle tue informazioni da parte di <strong>4AI S.r.l.</strong> esclusivamente per
                                    rispondere alla tua richiesta di contatto e organizzare una demo del prodotto{" "}
                                                            <strong>{projectName}</strong>, secondo quanto previsto dal GDPR.
                                </span>
                            </label>
                        </div>


                        <div className="flex flex-wrap items-center justify-between gap-3 pt-2">
                            <button
                                type="submit"
                                disabled={sending}
                                className="px-5 py-3 rounded-xl bg-[#7457FF] text-light font-medium hover:bg-[#5F49D8] shadow-lg shadow-[#7457FF]/20 disabled:opacity-60 disabled:cursor-not-allowed"
                            >
                                {sending ? "Invio in corso…" : "Invia richiesta"}
                            </button>

                            <p className="text-[11px] text-gray-500">
                                Nessuno spam. Ti risponderemo solo per questa richiesta.
                            </p>
                        </div>

                        <input type="hidden" name="project" value={projectName}/>
                    </form>
                </div>
            </div>
        </section>
    );
}
